export const OrderStatuses = { Pending: 1, Paid: 2, Delivered: 3, FailedPayment: 4, Cancelled: 5, Preparation: 6 };
export const OrderPaymentMethod = { CreditCard: 1, WireTransfer: 2 };
